import { GET_SETTING } from "../../actions/type";

  // activity intial state
  const initialSettings = {
    settings: null,
    isLoading: true,

  };
  
  export const reducer = (state = initialSettings, action) => {
    switch (action.type) {
      case GET_SETTING: {
        const settings = action.payload;
        return {
          ...state,
          settings: settings,
          isLoading: false,

        };
      }
     
      default:
        return state;
    }
  };